import { createReducer } from "redux-act";
import * as a from "../actions/reports";
let month = new Date().getMonth() + 1;
let year = new Date().getFullYear();

const DEFAULT_STATE = {
  data: [],
  filter: {
    employee: -1,
    costStatusOption: "all",
    month: month < 10 ? "0" + month : month,
    year: year,
  },
  loading: [],
};

export default createReducer(
  {
    [a.getReportingRequestSuccessful]: (state, payload) => {
      return {
        ...state,
        data: payload.data,
        loading: payload.loading,
      };
    },
    [a.getReportingRequestFailure]: (state, payload) => {
      return { ...state, loading: payload.loading };
    },
    [a.setFilter]: (state, payload) => {
      return {
        ...DEFAULT_STATE,
        filter: payload,
      };
    },
  },
  DEFAULT_STATE
);
